import React, { useEffect, useState } from 'react';
import {
  Box,
  GDSStyleObject,
  Checkbox,
  StackLayout,
} from '@leagueplatform/genesis-core';
import COBQuestioner from '../../../assets/json/COB_QUESTIONER.json';
import useCobStore from '../../../store/cob-store';
import { MedicareInfo, DependentInfo } from '../../../types/online-forms.types';
import '../forms.css';
import { COBLayout } from '../../cob-layout/cob-layout';

export function MedicareDependants(props: any) {
  // eslint-disable-next-line react/prop-types
  const { errorHandling, nextButtonClicked, noNext } = props;
  const [dependantSelected, setDependantSelected] = useState<MedicareInfo[]>();
  const [form] = useState({});
  // eslint-disable-next-line no-empty-pattern
  const cobResponse = useCobStore((state: any) => state.cobInformation);
  const dependantList = useCobStore((state: any) => state.demographics);
  const updateDependent = useCobStore((state: any) => state.updateDependents);
  const dependantOrder = dependantList.demographics?.dependents.sort(
    (a: any, b: any) => a.firstName.localeCompare(b.firstName),
  );

  const isDependentLength =
    dependantList?.demographics?.dependents.length === 4;
  const [checkedState, setCheckedState] = useState(
    new Array(dependantList?.demographics?.dependents.length).fill(false),
  );

  // const checkTheAvailability: boolean;
  const formField = false;
  const isValid = true;
  const defaultDependentProps = {
    claimNumber: '',
    eligibilityCriteria: '',
    disabilityBeginDate: '',
    socialSecurityDisabilityIncome: '',
    socialSecurityDisabilityIncomeStartDate: '',
    socialSecurityDisabilityIncomeEndDate: '',
    partAEffectiveDate: '',
    partACancelDate: '',
    partBEffectiveDate: '',
    partBCancelDate: '',
    partCCarrierName: '',
    partCPolicyNumber: '',
    partCGroupNumber: '',
    partCEffectiveDate: '',
    partCCancelDate: '',
    partDCarrierName: '',
    partDPolicyNumber: '',
    partDGroupNumber: '',
    partDEffectiveDate: '',
    partDCancelDate: '',
    bin: '',
    pcn: '',
    hasMedicare: '',
    partACoverage: '',
    partBCoverage: '',
    partCCoverage: '',
    partDCoverage: '',
  };

  const updateCobInformation = useCobStore(
    (state: any) => state.updateCobInformation,
  );
  const hasAdditionalDetails = cobResponse.additionalInsurance.find(
    (item: any) => item.hasAdditionalInsurance === 'Y',
  );
  const hasMedicareDetails = cobResponse.medicare.find(
    (item: any) => item.hasMedicare === 'Y',
  );

  useEffect(() => {
    if (formField) {
      errorHandling(false);
    } else {
      if (
        cobResponse?.additionalInsurance[0]?.hasAdditionalInsurance === 'N' &&
        cobResponse?.medicare[0]?.hasMedicare === 'N' &&
        hasMedicareDetails === undefined &&
        hasAdditionalDetails === undefined
      ) {
        noNext(true);
      } else {
        noNext(false);
      }
      errorHandling(true);
    }
  }, [
    cobResponse?.additionalInsurance,
    cobResponse?.medicare,
    errorHandling,
    formField,
    hasAdditionalDetails,
    hasMedicareDetails,
    noNext,
  ]);

  useEffect(() => {}, [
    dependantSelected,
    cobResponse,
    errorHandling,
    formField,
    noNext,
    nextButtonClicked,
    isValid,
    form,
    updateDependent,
  ]);

  const changeDateFormat = (demographicDOB: any) => {
    const date = new Date(demographicDOB); // Or your date here
    const utcDate = new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours(),
      date.getUTCMinutes(),
      date.getUTCSeconds(),
      date.getUTCMilliseconds(),
    );
    return `${
      utcDate.getMonth() < 9
        ? `0${utcDate.getMonth() + 1}`
        : parseInt(utcDate.getMonth().toString(), 10) + 1
    }/${
      utcDate.getDate() < 10
        ? `0${utcDate.getDate()}`
        : parseInt(utcDate.getDate().toString(), 10)
    }/${date.getUTCFullYear()}`;
  };

  const makeItSelected = (item: any) => {
    const isSelected = cobResponse.medicare.find(
      (medicareInsurance: any) =>
        medicareInsurance.member.firstName === item.firstName &&
        medicareInsurance.member.lastName === item.lastName &&
        medicareInsurance.member.dateOfBirth === item.dateOfBirth,
    );
    return isSelected === undefined ? false : isSelected?.hasMedicare === 'Y';
  };

  const removeObjectWithId = (
    dependentList: Array<MedicareInfo>,
    dependentDetail: DependentInfo,
  ) => {
    const objWithIdIndex = dependentList.findIndex(
      (dependent: any) =>
        dependent?.member?.firstName === dependentDetail?.firstName &&
        dependent?.member?.lastName === dependentDetail?.lastName &&
        dependent?.member?.dateOfBirth === dependentDetail?.dateOfBirth,
    );
    dependentList.splice(objWithIdIndex, 1);
    return dependentList;
  };

  const updateMedicareSelection = (selectedBeneficiary: DependentInfo) => {
    const foundMember = cobResponse.medicare.filter(
      // eslint-disable-next-line array-callback-return
      (item: any) =>
        item.member.firstName === selectedBeneficiary.firstName &&
        item.member.lastName === selectedBeneficiary.lastName,
    );
    foundMember[0].hasMedicare = 'Y';
  };

  const selectDependent = (
    e: any,
    selectedBeneficiary: DependentInfo,
    position: number,
  ) => {
    let currentSelectedDependents: Array<MedicareInfo> = [];
    let checkDependentAlreadyExist = false;
    // eslint-disable-next-line consistent-return
    cobResponse.medicare.forEach(
      // eslint-disable-next-line consistent-return
      (el: any) => {
        if (
          el.member.firstName === selectedBeneficiary.firstName &&
          el.member.lastName === selectedBeneficiary.lastName &&
          el.member.dateOfBirth === selectedBeneficiary.dateOfBirth
        ) {
          // eslint-disable-next-line no-param-reassign
          checkDependentAlreadyExist = true;
          return false;
        }
      },
    );

    if (e.target.checked && !checkDependentAlreadyExist) {
      defaultDependentProps.hasMedicare = 'Y';
      currentSelectedDependents.push({
        member: {
          firstName: Array.isArray(selectedBeneficiary)
            ? selectedBeneficiary[0].firstName
            : selectedBeneficiary.firstName,
          lastName: Array.isArray(selectedBeneficiary)
            ? selectedBeneficiary[0].lastName
            : selectedBeneficiary.lastName,
          suffix: '',
          gender: Array.isArray(selectedBeneficiary)
            ? selectedBeneficiary[0].gender
            : selectedBeneficiary.gender,
          dateOfBirth: Array.isArray(selectedBeneficiary)
            ? selectedBeneficiary[0].gender
            : selectedBeneficiary.dateOfBirth,
        },
        ...defaultDependentProps,
      });
      cobResponse.medicare.push(...currentSelectedDependents);
      // }

      updateCobInformation(cobResponse);

      // below line can be removed need to revisit
      updateDependent(currentSelectedDependents);
      setDependantSelected(currentSelectedDependents);
    } else if (e.target.checked && checkDependentAlreadyExist) {
      updateMedicareSelection(selectedBeneficiary);
      setDependantSelected(currentSelectedDependents);
    } else {
      currentSelectedDependents = removeObjectWithId(
        cobResponse.medicare,
        selectedBeneficiary,
      );

      // removeDependent(cobResponse, selectedBeneficiary.firstName, selectedBeneficiary.lastName);
      updateCobInformation(cobResponse);
      // below line can be removed need to revisit
      updateDependent(currentSelectedDependents);
      setDependantSelected(currentSelectedDependents);
    }
    const orderedList = cobResponse.medicare.sort((a: any, b: any) =>
      a.member.firstName.localeCompare(b.member.firstName),
    );
    updateCobInformation(orderedList);
    const updatedCheckedState = checkedState.map((item, index) =>
      index === position ? !item : item,
    );

    setCheckedState(updatedCheckedState);
    e.currentTarget.checked = makeItSelected(selectedBeneficiary);
  };

  return (
    <COBLayout
      title={COBQuestioner.COB.INFORMATION.INSURANCEINFO}
      questionTitle={COBQuestioner.COB.QUESTIONS.MEDICARECOVERAGE}
      disclaimer={COBQuestioner.COB.QUESTIONS.QUESTIONDISCLAIMER}
      dataTestId="medicare_dependent"
      dependantSize={isDependentLength}
      isDependant
    >
      <Box
        css={
          {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '$one $none $none $none',
          } as GDSStyleObject
        }
      >
        <StackLayout
          css={{
            width: '100%',
            minHeight: '350px',
          }}
        >
          {dependantList
            ? dependantOrder?.map((item: any, index: number) => (
                <Checkbox
                  label={`${item?.firstName} ${item?.lastName}`}
                  data-testid="checkbox"
                  name="dependent"
                  id={`dependant-${item?.firstName.toString()}`}
                  hint={changeDateFormat(item?.dateOfBirth)}
                  key={`dependant-${item?.firstName.toString()}`}
                  layout="row"
                  checked={makeItSelected(item)}
                  onChange={(e) => {
                    selectDependent(e, item, index);
                  }}
                  css={
                    {
                      width: '372px',
                      marginBottom: '15px',
                      '& label': {
                        boxShadow: '0px 2px 6px 0px #00000014',
                        border: '1px solid $onSurfaceBorderSubdued',
                        borderRadius: '7px',
                        height: '84px',
                        cursor: 'pointer',
                        '& span:first-child': {
                          paddingLeft: '8px',
                          span: {
                            display: 'block',
                          },
                        },
                        '& span:last-child': {
                          '& input': {
                            marginRight: '8px',
                          },
                        },
                      },
                    } as GDSStyleObject
                  }
                />
              ))
            : null}
        </StackLayout>
      </Box>
    </COBLayout>
  );
}
